import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-my-contractor-registration-action-cell',
  standalone: false,
  templateUrl: './my-contractor-registration-action-cell.component.html',
  styleUrls: ['./my-contractor-registration-action-cell.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MyContractorRegistrationActionCellComponent {
  @Input() row: any;

  @Input() viewDetails?: (row: any) => void;
  @Input() viewApplication?: (row: any) => void;
  @Input() renew?: (row: any) => void;
  @Input() delete?: (row: any) => void;
  @Input() disable?: (row: any) => void;
  @Input() enable?: (row: any) => void;

  onViewDetails(): void {
    this.viewDetails?.(this.row);
  }

  onViewApplication(): void {
    this.viewApplication?.(this.row);
  }

  onRenew(): void {
    if (!this.row?.canRenew) return;
    this.renew?.(this.row);
  }

  onDelete(): void {
    this.delete?.(this.row);
  }

  onDisable(): void {
    if (this.row?.isDisabled) return;
    this.disable?.(this.row);
  }

  onEnable(): void {
    if (!this.row?.isDisabled) return;
    this.enable?.(this.row);
  }
}
